export default __webpack_public_path__ + "static/media/sadface.1a7a9462.png";